import React, {useContext} from "react";
import {makeStyles} from "@material-ui/core";
import EventsForm from "./EventsForm/EventsForm";
import {ScreenDesignerContextNew} from "../../../../../../../../ContextComponents/ScreenDesignerContextNew";

const useStyles = makeStyles(() => ({
    wrapper: {
        width: '100%'
    },
    message: {
        paddingLeft: 25
    }
}));
export const schema = {
    button: {
        events: [{value: 'onClick', label: 'On Click'}],
        actions: [
            {label: 'Next Screen', value: 'nextScreen'},
            {label: 'Open Popup', value: 'openPopup'},
            {label: 'Open Drawer', value: 'openDrawer'},
            {label: 'Open Context Menu', value: 'openContext'},
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Return Value', value: 'returnValue'},
            {label: 'Set Filter', value: 'setFilter'},
            {label: 'Set List Data', value: 'setListData'},
            {label: 'Get List Data', value: 'getListData'},
            {label: 'Show Message', value: 'message'},
            {label: 'Upload File', value: 'uploadFile'},
            {label: 'Download File', value: 'downloadFile'},
            {label: 'Refresh Data', value: 'refreshData'},
            {label: 'Read Record', value: 'readRecord'},
            {label: 'Create Record', value: 'createEntity'},
            {label: 'Update Record', value: 'updateEntity'},
            {label: 'Delete Record', value: 'deleteEntity'},
            {label: 'Cancel', value: 'cancel'},
            {label: 'Start Process', value: 'startProcess'},
            {label: 'Start Task', value: 'startTask'},
            {label: 'Complete Task', value: 'completeTask'},
            {label: 'Delete Task', value: 'deleteTask'},
            {label: 'Execute JS', value: 'executeJs'},
            {label: 'Toggle Sidebar', value: 'toggleSidebar'},
            {label: 'External Link', value: 'externalLink'},
            {label: 'Scroll to Block', value: 'scrollToBlock'},
            {label: 'Camera Screenshot', value: 'cameraScreenshot'},
            {label: 'Disable All Fields', value: 'disableAllFields'},
            {label: 'Enable All Fields', value: 'enableAllFields'},
            {label: 'Upload Avatar', value: 'uploadAvatar'},
        ]
    },
    list: {
        events: [
            {label: 'On Click', value: 'onClick'},
            {label: "On Check", value: 'onCheck'},
            {label: 'On Right Click', value: 'onRightClick'},
            {label: 'On Double Click', value: 'onDoubleClick'},
            {label: 'On Focus', value: 'onFocus'},
            {label: 'On Load', value: 'onLoad'},
            {label: 'On Web Event', value: 'onWebEvent'},
            {label: 'On Apply Advanced Filter', value: 'onApplyAdvancedFilter'},
            {label: 'On Return Data', value: 'onReturnData'},
            {label: 'On Keydown', value: 'onKeydown'},
        ],
        actions: [
            {label: 'Next Screen', value: 'nextScreen'},
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Open Context Menu', value: 'openContext'},
            {label: 'Open Popup', value: 'openPopup'},
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Set Filter', value: 'setFilter'},
            {label: 'Set List Data', value: 'setListData'},
            {label: 'Get Data', value: 'getData'},
            {label: 'Track Changes', value: 'trackChange'},
            {label: 'Return Value', value: 'returnValue'},
            {label: 'Show Message', value: 'message'},
            {label: 'Download File', value: 'downloadFile'},
            {label: 'Execute JS', value: 'executeJs'},
        ]
    },
    field: {
        events: [
            {label: 'On Change', value: 'onChange'},
            {label: 'On Exit', value: 'onBlur'},
            {label: 'On Return Data', value: 'onReturnValue'},
            {label: 'On Keydown', value: 'onKeydown'},
        ],
        actions: [
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Set Filter', value: 'setFilter'},
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Read Record', value: 'readRecord'},
            {label: 'Show Message', value: 'message'},
            {label: 'Execute JS', value: 'executeJs'}
        ]
    },
    checkbox: {
        events: [
            {label: 'On Change', value: 'onChange'}
        ],
        actions: [
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Set Filter', value: 'setFilter'},
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Read Record', value: 'readRecord'},
            {label: 'Show Message', value: 'message'},
            {label: 'Execute JS', value: 'executeJs'}
        ]
    },
    radioGroup: {
        events: [
            {label: 'On Change', value: 'onChange'}
        ],
        actions: [
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Set Filter', value: 'setFilter'},
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Read Record', value: 'readRecord'},
            {label: 'Show Message', value: 'message'},
            {label: 'Execute JS', value: 'executeJs'}
        ]
    },
    switch: {
        events: [
            {label: 'On Change', value: 'onChange'}
        ],
        actions: [
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Set Filter', value: 'setFilter'},
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Read Record', value: 'readRecord'},
            {label: 'Show Message', value: 'message'},
            {label: 'Execute JS', value: 'executeJs'}
        ]
    },
    container: {
        events: [
            {label: 'On Open', value: 'onOpen'},
            {label: 'On Close', value: 'onClose'}
        ],
        actions: [
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Execute JS', value: 'executeJs'},
            {label: 'Read Record', value: 'readRecord'},
            {label: 'Set Filter', value: 'setFilter'},
            {label: 'Set List Data', value: 'setListData'},
            {label: 'Get List Data', value: 'getListData'},
            {label: 'Show Message', value: 'message'},
            {label: 'Start Process', value: 'startProcess'},
            {label: 'Start Task', value: 'startTask'},
            {label: 'Complete Task', value: 'completeTask'},
            {label: 'Delete Task', value: 'deleteTask'},
            {label: 'Disable All Fields', value: 'disableAllFields'},
            {label: 'Enable All Fields', value: 'enableAllFields'},
            {label: 'Confirm Close Screen', value: 'confirmCloseScreen'},
            {label: 'Open Popup', value: 'openPopup'},
        ]
    },
    reportContainer: {
        events: [{label: 'On Open', value: 'onOpen'}],
        actions: [
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Read Record', value: 'readRecord'},
            {label: 'Set Filter', value: 'setFilter'},
            {label: 'Execute JS', value: 'executeJs'},
            {label: 'Show Message', value: 'message'},
            {label: 'Start Process', value: 'startProcess'},
            {label: 'Start Task', value: 'startTask'},
            {label: 'Complete Task', value: 'completeTask'},
            {label: 'Delete Task', value: 'deleteTask'},
            {label: 'Show Message', value: 'message'},

        ]
    },
    stepper: {
        events: [
            {label: 'On Open', value: 'onOpen'},
            {label: 'On Finish', value: 'onFinish'},
            {label: 'On Delete', value: 'onDelete'},
        ],
        actions: [
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Read Record', value: 'readRecord'},
            {label: 'Next Screen', value: 'nextScreen'},
            {label: 'Set Filter', value: 'setFilter'},
            {label: 'Get List Data', value: 'getListData'},
            {label: 'Open Popup', value: 'openPopup'},
            {label: 'Execute JS', value: 'executeJs'},
            {label: 'Cancel', value: 'cancel'},
            {label: 'Show Message', value: 'message'},
            {label: 'Start Process', value: 'startProcess'},
            {label: 'Start Task', value: 'startTask'},
            {label: 'Complete Task', value: 'completeTask'},
            {label: 'Delete Task', value: 'deleteTask'},

        ]
    },
    step: {
        events: [
            {label: 'On Open', value: 'onOpen'},
            {label: 'On Click Next', value: 'onClickNext'},
            {label: 'On Web Event', value: 'onWebEvent'}
        ],
        actions: [
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Set Filter', value: 'setFilter'},
            {label: 'Get List Data', value: 'getListData'},
            {label: 'Read Record', value: 'readRecord'},
            {label: 'Show Message', value: 'message'},
            {label: 'Execute JS', value: 'executeJs'},
        ]
    },
    label: {
        events: [
            {label: 'On Load', value: 'onLoad'},
            {label: 'On Click', value: 'onClick'},
        ],
        actions: [
            {label: 'Set Styles', value: 'setStyles'},
            {label: 'Next Screen', value: 'nextScreen'},
            {label: 'Open Popup', value: 'openPopup'},
            {label: 'Open Context Menu', value: 'openContext'},
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Return Value', value: 'returnValue'},
            {label: 'Set Filter', value: 'setFilter'},
            {label: 'Set List Data', value: 'setListData'},
            {label: 'Get List Data', value: 'getListData'},
            {label: 'Show Message', value: 'message'},
            {label: 'Upload File', value: 'uploadFile'},
            {label: 'Download File', value: 'downloadFile'},
            {label: 'Execute JS', value: 'executeJs'},
            {label: 'Toggle Sidebar', value: 'toggleSidebar'},
        ]
    },
    contextItem: {
        events: [{value: 'onClick', label: 'On Click'}],
        actions: [
            {label: 'Next Screen', value: 'nextScreen'},
            {label: 'Open Popup', value: 'openPopup'},
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Return Value', value: 'returnValue'},
            {label: 'Set Filter', value: 'setFilter'},
            {label: 'Set List Data', value: 'setListData'},
            {label: 'Get List Data', value: 'getListData'},
            {label: 'Show Message', value: 'message'},
            {label: 'Upload File', value: 'uploadFile'},
            {label: 'Download File', value: 'downloadFile'},
            {label: 'Refresh Data', value: 'refreshData'},
            {label: 'Read Record', value: 'readRecord'},
            {label: 'Create Record', value: 'createEntity'},
            {label: 'Update Record', value: 'updateEntity'},
            {label: 'Delete Record', value: 'deleteEntity'},
            {label: 'Cancel', value: 'cancel'},
            {label: 'Start Process', value: 'startProcess'},
            {label: 'Start Task', value: 'startTask'},
            {label: 'Complete Task', value: 'completeTask'},
            {label: 'Delete Task', value: 'deleteTask'},
            {label: 'Execute JS', value: 'executeJs'},
        ]
    },
    onClosePopup: {
        actions: [
            {label: 'Next Screen', value: 'nextScreen'},
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Return Value', value: 'returnValue'},
            {label: 'Set Filter', value: 'setFilter'},
            {label: 'Set List Data', value: 'setListData'},
            {label: 'Get List Data', value: 'getListData'},
            {label: 'Show Message', value: 'message'},
            {label: 'Upload File', value: 'uploadFile'},
            {label: 'Download File', value: 'downloadFile'},
            {label: 'Refresh Data', value: 'refreshData'},
            {label: 'Read Record', value: 'readRecord'},
            {label: 'Create Record', value: 'createEntity'},
            {label: 'Update Record', value: 'updateEntity'},
            {label: 'Delete Record', value: 'deleteEntity'},
            {label: 'Cancel', value: 'cancel'},
            {label: 'Start Process', value: 'startProcess'},
            {label: 'Start Task', value: 'startTask'},
            {label: 'Complete Task', value: 'completeTask'},
            {label: 'Delete Task', value: 'deleteTask'},
            {label: 'Execute JS', value: 'executeJs'},
        ]
    },
    image: {
        events: [{value: 'onClick', label: 'On Click'}],
        actions: [
            {label: 'Upload File', value: 'uploadFile'},
            {label: 'Upload Avatar', value: 'uploadAvatar'},
            {label: 'Toggle Sidebar', value: 'toggleSidebar'},
            {label: 'Execute JS', value: 'executeJs'},
            {label: 'External Link', value: 'externalLink'}
        ]
    },
    navigationItem: {
        events: [{value: 'onClick', label: 'On Click'}],
        actions: [
            {label: 'Next Screen', value: 'nextScreen'},
            {label: 'Open Popup', value: 'openPopup'},
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Set Filter', value: 'setFilter'},
            {label: 'Set List Data', value: 'setListData'},
            {label: 'Get List Data', value: 'getListData'},
            {label: 'Show Message', value: 'message'},
            {label: 'Refresh Data', value: 'refreshData'},
            {label: 'Read Record', value: 'readRecord'},
            {label: 'Cancel', value: 'cancel'},
            {label: 'Start Process', value: 'startProcess'},
            {label: 'Start Task', value: 'startTask'},
            {label: 'Complete Task', value: 'completeTask'},
            {label: 'Delete Task', value: 'deleteTask'},
            {label: 'Execute JS', value: 'executeJs'},
        ]
    },
    icon: {
        events: [{value: 'onClick', label: 'On Click'}],
        actions: [
            {label: 'Next Screen', value: 'nextScreen'},
            {label: 'Open Popup', value: 'openPopup'},
            {label: 'Open Context Menu', value: 'openContext'},
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Return Value', value: 'returnValue'},
            {label: 'Set Filter', value: 'setFilter'},
            {label: 'Set List Data', value: 'setListData'},
            {label: 'Get List Data', value: 'getListData'},
            {label: 'Show Message', value: 'message'},
            {label: 'Upload File', value: 'uploadFile'},
            {label: 'Download File', value: 'downloadFile'},
            {label: 'Refresh Data', value: 'refreshData'},
            {label: 'Read Record', value: 'readRecord'},
            {label: 'Create Record', value: 'createEntity'},
            {label: 'Update Record', value: 'updateEntity'},
            {label: 'Delete Record', value: 'deleteEntity'},
            {label: 'Cancel', value: 'cancel'},
            {label: 'Start Process', value: 'startProcess'},
            {label: 'Start Task', value: 'startTask'},
            {label: 'Complete Task', value: 'completeTask'},
            {label: 'Delete Task', value: 'deleteTask'},
            {label: 'Execute JS', value: 'executeJs'},
        ]
    },
    card: {
        events: [{value: 'onClick', label: 'On Click'}, {value: 'onLoad', label: 'On Load'}],
        actions: [
            {label: 'Next Screen', value: 'nextScreen'},
            {label: 'Open Popup', value: 'openPopup'},
            {label: 'Open Context Menu', value: 'openContext'},
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Return Value', value: 'returnValue'},
            {label: 'Set Filter', value: 'setFilter'},
            {label: 'Set List Data', value: 'setListData'},
            {label: 'Get List Data', value: 'getListData'},
            {label: 'Show Message', value: 'message'},
            {label: 'Upload File', value: 'uploadFile'},
            {label: 'Download File', value: 'downloadFile'},
            {label: 'Refresh Data', value: 'refreshData'},
            {label: 'Read Record', value: 'readRecord'},
            {label: 'Create Record', value: 'createEntity'},
            {label: 'Update Record', value: 'updateEntity'},
            {label: 'Delete Record', value: 'deleteEntity'},
            {label: 'Cancel', value: 'cancel'},
            {label: 'Start Process', value: 'startProcess'},
            {label: 'Start Task', value: 'startTask'},
            {label: 'Complete Task', value: 'completeTask'},
            {label: 'Delete Task', value: 'deleteTask'},
            {label: 'Set Styles', value: 'setStyles'},
            {label: 'Execute JS', value: 'executeJs'},
        ]
    },
    block: {
        events: [
            {value: 'onClick', label: 'On Click'},
            {value: 'onLoad', label: 'On Open'}
        ],
        actions: [
            {label: 'Next Screen', value: 'nextScreen'},
            {label: 'Open Popup', value: 'openPopup'},
            {label: 'Open Drawer', value: 'openDrawer'},
            {label: 'Open Context Menu', value: 'openContext'},
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Return Value', value: 'returnValue'},
            {label: 'Set Filter', value: 'setFilter'},
            {label: 'Set List Data', value: 'setListData'},
            {label: 'Get List Data', value: 'getListData'},
            {label: 'Show Message', value: 'message'},
            {label: 'Upload File', value: 'uploadFile'},
            {label: 'Download File', value: 'downloadFile'},
            {label: 'Refresh Data', value: 'refreshData'},
            {label: 'Read Record', value: 'readRecord'},
            {label: 'Create Record', value: 'createEntity'},
            {label: 'Update Record', value: 'updateEntity'},
            {label: 'Delete Record', value: 'deleteEntity'},
            {label: 'Cancel', value: 'cancel'},
            {label: 'Start Process', value: 'startProcess'},
            {label: 'Start Task', value: 'startTask'},
            {label: 'Complete Task', value: 'completeTask'},
            {label: 'Delete Task', value: 'deleteTask'},
            {label: 'Execute JS', value: 'executeJs'},
            {label: 'External Link', value: 'externalLink'},
            {label: 'Scroll to Block', value: 'scrollToBlock'},
            {label: 'Set Styles', value: 'setStyles'},
        ]
    },
    forEach: {
        events: [
            {label: 'On Load', value: 'onLoad'}
        ],
        actions: [
            {label: 'Set Filter', value: 'setFilter'}
        ]
    },
    feed: {
        events: [
            {label: 'On Load', value: 'onLoad'}
        ],
        actions: [
            {label: 'Set Filter', value: 'setFilter'}
        ]
    },
    interval: {
        events: [{value: 'onTick', label: 'On Tick'}],
        actions: [
            {label: 'Next Screen', value: 'nextScreen'},
            {label: 'Open Popup', value: 'openPopup'},
            {label: 'Open Context Menu', value: 'openContext'},
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Return Value', value: 'returnValue'},
            {label: 'Set Filter', value: 'setFilter'},
            {label: 'Set List Data', value: 'setListData'},
            {label: 'Get List Data', value: 'getListData'},
            {label: 'Show Message', value: 'message'},
            {label: 'Upload File', value: 'uploadFile'},
            {label: 'Download File', value: 'downloadFile'},
            {label: 'Refresh Data', value: 'refreshData'},
            {label: 'Read Record', value: 'readRecord'},
            {label: 'Create Record', value: 'createEntity'},
            {label: 'Update Record', value: 'updateEntity'},
            {label: 'Delete Record', value: 'deleteEntity'},
            {label: 'Cancel', value: 'cancel'},
            {label: 'Start Process', value: 'startProcess'},
            {label: 'Start Task', value: 'startTask'},
            {label: 'Complete Task', value: 'completeTask'},
            {label: 'Delete Task', value: 'deleteTask'},
            {label: 'Execute JS', value: 'executeJs'},
            {label: 'Toggle Sidebar', value: 'toggleSidebar'},
        ]
    },
    menuItem: {
        events: [
            {value: 'onClick', label: 'On Click'},
            {label: 'On Load', value: 'onLoad'},
            {label: 'On Web Event', value: 'onWebEvent'},
        ],
        actions: [
            {label: 'Open Popup', value: 'openPopup'},
            {label: 'Next Screen', value: 'nextScreen'},
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Get List Data', value: 'getListData'},
            {label: 'Show Message', value: 'message'},
            {label: 'Upload File', value: 'uploadFile'},
            {label: 'Download File', value: 'downloadFile'},
            {label: 'Refresh Data', value: 'refreshData'},
            {label: 'Read Record', value: 'readRecord'},
            {label: 'Start Process', value: 'startProcess'},
            {label: 'Start Task', value: 'startTask'},
            {label: 'Complete Task', value: 'completeTask'},
            {label: 'Execute JS', value: 'executeJs'},
            {label: 'Toggle Sidebar', value: 'toggleSidebar'},
            {label: 'External Link', value: 'externalLink'},
            {label: 'Set Styles', value: 'setStyles'},
        ]
    },
    options: {
        events: [
            {value: 'onClick', label: 'On Select'},
            {value: 'onLoad', label: 'On Load'}
        ],
        actions: [
            {label: 'Next Screen', value: 'nextScreen'},
            {label: 'Open Popup', value: 'openPopup'},
            {label: 'Open Context Menu', value: 'openContext'},
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Return Value', value: 'returnValue'},
            {label: 'Set Filter', value: 'setFilter'},
            {label: 'Set List Data', value: 'setListData'},
            {label: 'Get List Data', value: 'getListData'},
            {label: 'Show Message', value: 'message'},
            {label: 'Upload File', value: 'uploadFile'},
            {label: 'Download File', value: 'downloadFile'},
            {label: 'Refresh Data', value: 'refreshData'},
            {label: 'Read Record', value: 'readRecord'},
            {label: 'Create Record', value: 'createEntity'},
            {label: 'Update Record', value: 'updateEntity'},
            {label: 'Delete Record', value: 'deleteEntity'},
            {label: 'Cancel', value: 'cancel'},
            {label: 'Start Process', value: 'startProcess'},
            {label: 'Start Task', value: 'startTask'},
            {label: 'Complete Task', value: 'completeTask'},
            {label: 'Delete Task', value: 'deleteTask'},
            {label: 'Execute JS', value: 'executeJs'},
            {label: 'Toggle Sidebar', value: 'toggleSidebar'},
            {label: 'External Link', value: 'externalLink'},
            {label: 'Scroll to Block', value: 'scrollToBlock'},
        ]
    },
    selectionCriteria: {
        events: [
            {value: 'onApply', label: 'On Apply'},
        ],
        actions: [
            {label: 'Next Screen', value: 'nextScreen'},
            {label: 'Open Popup', value: 'openPopup'},
            {label: 'Open Context Menu', value: 'openContext'},
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Return Value', value: 'returnValue'},
            {label: 'Set Filter', value: 'setFilter'},
            {label: 'Set List Data', value: 'setListData'},
            {label: 'Get List Data', value: 'getListData'},
            {label: 'Show Message', value: 'message'},
            {label: 'Upload File', value: 'uploadFile'},
            {label: 'Download File', value: 'downloadFile'},
            {label: 'Refresh Data', value: 'refreshData'},
            {label: 'Read Record', value: 'readRecord'},
            {label: 'Create Record', value: 'createEntity'},
            {label: 'Update Record', value: 'updateEntity'},
            {label: 'Delete Record', value: 'deleteEntity'},
            {label: 'Cancel', value: 'cancel'},
            {label: 'Start Process', value: 'startProcess'},
            {label: 'Start Task', value: 'startTask'},
            {label: 'Complete Task', value: 'completeTask'},
            {label: 'Delete Task', value: 'deleteTask'},
            {label: 'Execute JS', value: 'executeJs'},
            {label: 'Toggle Sidebar', value: 'toggleSidebar'},
            {label: 'External Link', value: 'externalLink'},
            {label: 'Scroll to Block', value: 'scrollToBlock'},
        ]
    },
    dropzone: {
        events: [{value: 'onDrop', label: 'On Drop'}],
        actions: [
            {label: 'Execute JS', value: 'executeJs'},
        ]
    },
    endpoint: {
        events: [
            {value: 'before', label: "Before"},
            {value: 'afterSuccess', label: "After Success"},
            {value: 'afterError', label: "After Error"}
        ],
        actions: [
            {label: 'Execute JS', value: 'executeJs'},
            {label: 'Show Message', value: 'message'},
        ]
    },
    badge: {
        events: [{label: 'On Web Event', value: 'onWebEvent'},],
        actions: [
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Show Message', value: 'message'},
            {label: 'Execute JS', value: 'executeJs'},
        ]
    },
    shortcut: {
        events: [{value: 'onClick', label: 'On Keydown'}],
        actions: [
            {label: 'Next Screen', value: 'nextScreen'},
            {label: 'Open Popup', value: 'openPopup'},
            {label: 'Open Context Menu', value: 'openContext'},
            {label: 'Send Request', value: 'sendRequest'},
            {label: 'Set Variable', value: 'setVariable'},
            {label: 'Return Value', value: 'returnValue'},
            {label: 'Set Filter', value: 'setFilter'},
            {label: 'Set List Data', value: 'setListData'},
            {label: 'Get List Data', value: 'getListData'},
            {label: 'Show Message', value: 'message'},
            {label: 'Upload File', value: 'uploadFile'},
            {label: 'Download File', value: 'downloadFile'},
            {label: 'Refresh Data', value: 'refreshData'},
            {label: 'Read Record', value: 'readRecord'},
            {label: 'Create Record', value: 'createEntity'},
            {label: 'Update Record', value: 'updateEntity'},
            {label: 'Delete Record', value: 'deleteEntity'},
            {label: 'Cancel', value: 'cancel'},
            {label: 'Start Process', value: 'startProcess'},
            {label: 'Start Task', value: 'startTask'},
            {label: 'Complete Task', value: 'completeTask'},
            {label: 'Delete Task', value: 'deleteTask'},
            {label: 'Execute JS', value: 'executeJs'},
            {label: 'Toggle Sidebar', value: 'toggleSidebar'},
            {label: 'External Link', value: 'externalLink'},
            {label: 'Scroll to Block', value: 'scrollToBlock'},
            {label: 'Camera Screenshot', value: 'cameraScreenshot'},
        ]
    },
    table: {
        events: [{value: 'onClick', label: 'On Click'}],
        actions: [
            {label: 'Next Screen', value: 'nextScreen'},
            {label: 'Open Popup', value: 'openPopup'},
            {label: 'Open Context Menu', value: 'openContext'},
            {label: 'Execute JS', value: 'executeJs'},
        ]
    },
    tree: {
        events: [{value: 'onDoubleClick', label: 'On Double Click'}],
        actions: [
            {label: 'Next Screen', value: 'nextScreen'},
            {label: 'Open Popup', value: 'openPopup'},
            {label: 'Open Context Menu', value: 'openContext'},
            {label: 'Execute JS', value: 'executeJs'},
        ]
    }
};

const Events = () => {
    const {selectedComponent: {component}} = useContext(ScreenDesignerContextNew);
    const classes = useStyles();
    return (
        <div className={classes.wrapper}>
            <EventsForm schema={schema[component.type]}/>
        </div>
    );
};

export default Events;
